import { ColumnAdapter } from '@makyoapp/makyo-common'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { cn } from '@/lib/cn'
import { SHOW_SEARCH_LIMIT } from '@/shared/constants'

import { RenderColumn } from '../RenderColumn'

export function VariableColumnDd({
  id,
  col,
  setCol,
  colOptions,
  portalMenu = true,
  className,
  rightSection,
}: {
  id?: string
  col?: string
  setCol: (next: string) => void
  colOptions: ColumnAdapter[]
  portalMenu?: boolean
  className?: string
  rightSection?: React.ReactNode
}) {
  return (
    <div className={cn('px-2 w-full relative', className)}>
      <SelectDropdown
        id={id}
        value={colOptions.find((c) => c.id === col)}
        onChange={(c, e) => {
          e.preventDefault()
          e.stopPropagation()
          setCol(c.id)
        }}
        portalMenu={portalMenu}
        withSearch={colOptions.length > SHOW_SEARCH_LIMIT}
        menuZIndex='z-302'
        menuContainerClassName='mk-ag-sdd'
        options={colOptions}
        optionLabel={(col) => `${col?.name}`}
        renderOption={(col) => <RenderColumn withStyle={false} col={col} />}
      />
      {rightSection}
    </div>
  )
}
